import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  Layout,
  Breadcrumb,
  Form,
  Input,
  DatePicker,
  Radio,
  Modal,
  Select,
  Switch,
  Button,
  Table,
  message,
  notification,
  Skeleton,
  InputNumber,
  List,
  Divider,
  Avatar,
} from 'antd';
import {
  EyeOutlined,
  BookOutlined,
  UploadOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import { DragDropContext, DragSource, DropTarget } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import _ from 'lodash';
import styles from './styles.module.scss';
import whttp from '../../libs/whttp';
import { API_HOST, Role, GOOGLE_MAP_KEY } from '../../configs/env';
import AppHelper from 'libs/AppHelper';
import CitySelect from 'components/CitySelect/CitySelect';
import WUpload, { AvatarUpload } from 'components/WUpload/WUpload';
import DeleteConfirmButton from 'components/DeleteConfirmButton/DeleteConfirmButton';
import { genFormItemAtrribute } from 'libs/FormHelper';
import Validator from 'validatorjs';
import Errors from 'validatorjs/src/errors';
import ValidatorErrorAlert from '../../components/ValidatorErrorAlert/ValidatorErrorAlert';
import moment from 'moment';
import BraftEditor from 'braft-editor';
import Search from 'antd/lib/input/Search';
import { TabletView } from 'react-device-detect';

const Option = Select.Option;

const cardBodyStyle = { padding: 8, fontSize: 8 };
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 };

@DragDropContext(HTML5Backend)
export default class RecipeInfo extends Component {
  formRef = React.createRef();

  state = {
    tableData: {
      current: 0, //目前頁數
      page_size: 10, //一頁幾筆
      total: 0, //以此query條件，總共幾筆資料
      rows: [],
    },
    recipeInfo: {
      id: null,
      status: 1,
      name: null,
      logo: null,
      type: 1,
      ingredients: [{}, {}],
    },
    data: [],
    messages: {},
    isFetchData: false,
    isSubmitData: false,
    isPreviewData: false,
    source: null,
    additional: null,
    searchTotal: 0,
    searchOrder: 0,
    value: null,
    searchTitle: '',
  };

  componentDidMount() {
    AppHelper.updateConfig();

    this.fetchData();
    this.fillData();
  }

  fillData = (data = _.cloneDeep(devRecipeInfo)) => {
    if (!this.formRef.current) return;

    // 處理資料，本地適合Form Control的資料
    if (!_.isString(data.cover)) {
      data.cover = null;
    } else {
      data.cover = {
        id: 1,
        path: data.cover,
        url: data.cover_url,
      };
    }

    data.show_range = [
      _.get(data, 'show_at') ? moment(_.get(data, 'show_at')) : null,
      _.get(data, 'show_at') ? moment(_.get(data, 'hide_at')) : null,
    ];
    // data.promotion_date_range = [moment(_.get(data, 'promotion_start_date')), moment(_.get(data, 'promotion_end_date'))]

    if (!_.isBoolean(data.status)) data.status = data.status === 1;

    _.set(this, 'state.source', data.source);
    // _.set(this, 'state.additional',data.additional)
    data.source = BraftEditor.createEditorState(data.source);
    // data.additional=BraftEditor.createEditorState(data.additional)

    this.formRef.current.setFieldsValue(data);
  };
  // 抓取頁面資訊
  fetchData = () => {
    const id = _.get(this, 'props.match.params.id');

    if (!id) return;

    this.setState({ isFetchData: true, isPreviewData: true });
    whttp.get(API_HOST + `/api/mgt/v1/recipes/${id}`, null, (state, res) => {
      this.setState({ isFetchData: false });

      const { code = 100, reason = '發生錯誤', data = {} } = res;

      console.log(code, reason, data, res);

      if (state === false || code !== 200) {
        message.warning(reason);
        this.props.history.replace('/recipes');
        return;
      }

      this.fillData(data);
    });
  };
  submitData = (recipeInfo = {}) => {
    window.cc = this.formRef.current;
    console.log('this.formRef.current', this.formRef.current);
    // 把Control元件轉換回上傳資料
    recipeInfo.cover = _.get(recipeInfo, 'cover.path');
    recipeInfo.show_at = _.get(recipeInfo, 'show_range.0')
      ? _.get(recipeInfo, 'show_range.0').format('YYYY-MM-DD HH:mm:ss')
      : null;
    recipeInfo.hide_at = _.get(recipeInfo, 'show_range.1')
      ? _.get(recipeInfo, 'show_range.1').format('YYYY-MM-DD HH:mm:ss')
      : null;
    var source = _.get(this, 'state.source').toHTML();
    source = _.get(this, 'state.source').toHTML();
    // var additional = _.get(this,'state.additional').toHTML()
    // additional     = _.get(this,'state.additional').toHTML()
    recipeInfo.source = source;
    // recipeInfo.additional = additional
    delete recipeInfo.show_range;
    recipeInfo.steps = _.map(recipeInfo.steps, (step) => ({
      ...step,
      image: {
        uid: _.get(step, 'image.uid'),
        name: _.get(step, 'image.name'),
        path: _.get(
          step,
          'image.path',
          _.get(step, 'image.response.data.path')
        ),
        url: _.get(step, 'image.url', _.get(step, 'image.response.data.url')),
      },
    }));
    console.log('submitData', recipeInfo);
    const current_user = _.get(window, 'VC_CONFIG.WP_CURRENT_USER', '');
    recipeInfo.user_id = current_user.ID;
    const id = _.get(this, 'props.match.params.id', '');

    this.setState({ isSubmitData: true, messages: {} });

    whttp.post(
      API_HOST + `/api/mgt/v1/recipes/${id}`,
      recipeInfo,
      (state, res) => {
        console.log(state, res);
        this.setState({ isSubmitData: false });

        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return message.error('發生錯誤');
        }

        if (code !== 200) {
          notification['error']({
            message: '更新失敗',
            description: reason,
          });
          const messages = data.messages;
          if (_.isObject(messages)) {
            //處理錯誤訊息
            _.map(messages, (errors, key) => {
              console.log('map', key, errors);
              return {
                touched: true,
                validating: false,
                errors: [],
                name: [key],
                value: this.getFieldValue(key),
              };
            });
            this.forceUpdate();
            console.log('this.formRef.current', this.formRef.current);
          }
          return this.setState({ messages: data.messages || {} });
        }

        const { data: { id: new_id } = {} } = res;

        if (new_id != id) {
          message.success('新增成功');
          this.setState({ recipeInfo: data });

          return this.props.history.replace(`/recipes/view/${new_id}`);
        }

        message.success('更新成功');
      }
    );
  };

  deleteUser = (e) => {
    const id = _.get(this, 'props.match.params.id');

    if (!id) return;

    this.setState({ isDeleteUser: true });
    whttp.delete(API_HOST + `/api/mgt/v1/recipes/${id}`, {}, (state, res) => {
      this.setState({ isDeleteUser: false });
      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false) {
        return message.error('發生錯誤');
      }

      if (code !== 200) {
        return message.error(reason);
      }

      notification['success']({
        message: '刪除成功',
      });

      return this.props.history.replace(`/recipes`);
    });
  };
  getImages = () => {
    return this.formRef.current &&
      _.isArray(this.formRef.current.getFieldValue('images'))
      ? this.formRef.current.getFieldValue('images')
      : [];
  };
  moveRow = (dragIndex, hoverIndex) => {
    const { table_data = {}, table_data: { rows = [] } = {} } = this.state;
    let images = this.getImages();
    const dragRow = images[dragIndex];

    images = update(images, {
      $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
    });

    this.formRef.current.setFields([
      {
        touched: true,
        validating: false,
        errors: [],
        name: ['images'],
        value: images,
      },
    ]);
  };

  getFieldValue = (key, defaultValue = undefined) => {
    return this.formRef.current
      ? this.formRef.current.getFieldValue(key)
      : defaultValue;
  };

  //預覽食譜資訊
  previewRecipe = () => {
    const recipe = _.get(this, 'props.match.params.name');
    const id = _.get(this, 'props.match.params.id');
    if (!id) return;
    let INDEX_URL = _.get(window, 'VC_CONFIG.INDEX_URL');
    if (recipe && recipe > 0) {
      window.open(INDEX_URL + `/recipe-info-preview/?recipe=${id}`);
      return;
    }
  };

  enterNotSubmit = (e) => {
    if (e.key === 'Enter') {
      let value = e.target + '';
      if (value.indexOf('TextArea') !== -1) {
        console.log('TextArea');
      } else e.preventDefault();
    }
  };

  sourceChange = (editorState) => {
    this.setState({
      source: editorState,
    });
  };

  // additionalChange = (editorState) => {
  //   this.setState({
  //     additional: editorState
  //   })
  // }

  productSearch = (value, idx, title) => {
    console.log('搜尋: ', value, ' idx: ', idx);
    this.setState({ searchOrder: idx });
    this.setState({ value: value });
    this.setState({ searchTitle: title });

    whttp.get(
      API_HOST + `/api/v1/products/`,
      {
        keyword: value,
      },
      (state, res) => {
        this.setState({ isFetchData: false });

        const { code = 100, reason = '發生錯誤', data = {} } = res;

        console.log(code, reason, data, res);

        if (state === false || code !== 200) {
          message.warning(reason);
          return;
        }
        console.log('fillData', data);
        this.fillData(data);
        this.setState({ tableData: data });

        console.log('total: ', data.total);
        this.setState({ searchTotal: data.total });
      }
    );
  };

  // 拉Table資料
  loadData = (opt = { page: 1, page_size: 10 }) => {
    const { page, page_size } = opt;
    console.log('tableData: ', this.state.tableData);
    this.setState({ isLoadingData: true });

    whttp.get(
      API_HOST + `/api/v1/products/`,
      {
        page: page,
        page_size: page_size,
        keyword: this.state.value,
      },
      (state, res) => {
        this.setState({ isLoadingData: false });
        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return this.setState({ message: '發生錯誤' });
        }

        if (code !== 200) {
          return this.setState({ message: reason });
        }

        this.setState({ tableData: data });
      }
    );
  };

  selectProduct = (item) => {
    let idx = this.state.searchOrder;
    let title = this.state.searchTitle;
    console.log('item: ', item);
    console.log('id: ', item.id);
    console.log('idx: ', idx);
    console.log('title: ', title);
    this.formRef.current.setFields([
      {
        name: [title, idx, 'id'],
        value: item.id,
        touched: true,
        validating: false,
        errors: [],
      },
    ]);
  };

  render() {
    // 登入使用者的權限
    const errors = _.get(this, 'state.validator.errors', new Errors());
    const editorPermissions = _.get(this.props, 'auth.permissions', {});
    const options = _.get(this, 'props.app.options', {});
    const pdf = this.getFieldValue('pdf');
    const id = _.get(this, 'props.match.params.id');
    const source = _.get(this, 'state.source');
    // const additional = _.get(this, 'state.additional')
    const controls = [
      'font-size',
      'line-height',
      'text-color',
      'bold',
      'italic',
      'underline',
      'text-align',
      'text-color',
      'blockquote',
      'separator',
      'headings',
      'undo',
      'redo',
      'separator',
      'link',
      'separator',
    ];
    const { tableQuery = {}, tableData = {} } = this.state;
    const searchTotal = this.state.searchTotal;
    const searchTitle = this.state.searchTitle;

    return (
      <Layout className={styles.container}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to={`/recipes`}>食譜管理</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>食譜資訊</Breadcrumb.Item>
        </Breadcrumb>

        <h2>食譜資訊</h2>

        <ValidatorErrorAlert errors={errors} />

        <Skeleton loading={this.state.isFetchData}>
          <div className='block search'>
            <Form
              ref={this.formRef}
              name='basic'
              className='basicForm'
              layout='vertical'
              onFinish={(values) => this.submitData(values)}
              onValuesChange={(changedFields, allFields) =>
                console.log('onValuesChange', changedFields)
              }
              onKeyDown={(e) => {
                this.enterNotSubmit(e);
              }}
            >
              <Form.Item
                style={{ textAlign: 'right' }}
                taillayout={{ wrapperCol: { offset: 8, span: 16 } }}
              >
                <Button
                  type='primary'
                  htmlType='submit'
                  style={{ marginLeft: 8 }}
                  loading={this.state.isSubmitData}
                >
                  儲存
                </Button>
                <Button
                  type='primary'
                  style={{ marginLeft: 8 }}
                  disabled={id == undefined}
                  onClick={this.previewRecipe}
                >
                  預覽
                </Button>
              </Form.Item>

              <div className='flexBox'>
                <Form.Item
                  {...genFormItemAtrribute('name', '名稱')}
                  rules={[{ required: true, message: '請填寫名稱' }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  {...genFormItemAtrribute('status', '狀態', 'checked')}
                >
                  <Switch checkedChildren='啟用' unCheckedChildren='停用' />
                </Form.Item>
              </div>
              <div className='flexBox'>
                <Form.Item
                  {...genFormItemAtrribute('show_range', '系統上下架時間')}
                  extra='系統於該時段顯示於官網，注意狀態需為「啟用」。'
                >
                  <DatePicker.RangePicker
                    showTime={{
                      defaultValue: [
                        moment('09:00:00', 'HH:mm:ss'),
                        moment('23:59:59', 'HH:mm:ss'),
                      ],
                      format: 'HH:mm',
                    }}
                    format='YYYY-MM-DD HH:mm'
                  />
                </Form.Item>
                <Form.Item {...genFormItemAtrribute('sort', '排序')}>
                  <InputNumber style={{ width: '100%' }} min={0} />
                </Form.Item>
              </div>
              <div className='flexBox'>
                <Form.Item {...genFormItemAtrribute('level', '難度')}>
                  <Select>
                    <Option value={0}>入門</Option>
                    <Option value={1}>進階</Option>
                    <Option value={2}>大師</Option>
                    <Option value={3}>神級</Option>
                  </Select>
                </Form.Item>

                <Form.Item {...genFormItemAtrribute('portion', '人份')}>
                  <InputNumber style={{ width: '100%' }} min={1} />
                </Form.Item>
              </div>

              <Form.Item
                {...genFormItemAtrribute('category_id', '食譜類別')}
                rules={[{ required: true, message: '請選擇目錄類別' }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {_.map(_.get(options, 'recipe_categories', []), (item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <div className='flexBox'>
                <Form.Item {...genFormItemAtrribute('desc', '食譜說明')}>
                  <Input.TextArea rows={5} />
                </Form.Item>
              </div>

              <Form.Item
                {...genFormItemAtrribute('youtube', 'Youtube連結')}
                rules={[{ type: 'url', message: '請填寫正確連結' }]}
                extra={
                  <a
                    href='https://support.google.com/youtube/answer/57741?hl=zh-Hant&co=GENIE.Platform=Desktop'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    複製Youtube連結 <QuestionCircleOutlined />
                  </a>
                }
              >
                <Input />
              </Form.Item>

              <div className='flexBox'>
                <Form.Item
                  {...genFormItemAtrribute('prepare_time', '準備時間（分鐘）')}
                >
                  <InputNumber style={{ width: '100%' }} min={0} />
                </Form.Item>
                <Form.Item
                  {...genFormItemAtrribute('cook_time', '烹調時間（分鐘）')}
                >
                  <InputNumber style={{ width: '100%' }} min={0} />
                </Form.Item>
              </div>

              <Divider>簡介圖片集</Divider>
              <span>此區塊操作後還需按下上方的「儲存」資料方得保留</span>
              <div className='flexBox'>
                <Form.Item label='封面' style={{ minHeight: 166 }}>
                  <Form.List name='images'>
                    {() => {
                      const url = _.get(this.getFieldValue('images'), '0.url');
                      return (
                        <Avatar
                          shape='square'
                          size={128}
                          style={{ height: 166 }}
                          icon={<BookOutlined />}
                          src={url}
                        />
                      );
                    }}
                  </Form.List>
                </Form.Item>
              </div>
              <Form.Item>
                <Form.Item
                  {...genFormItemAtrribute('images', '圖片上傳 寬800x高800')}
                  valuePropName='fileList'
                  extra='寬800x高800，第一張圖片為封面'
                >
                  <WUpload multiple={true} showUploadList={false}>
                    <Button>
                      <UploadOutlined /> 上傳
                    </Button>
                  </WUpload>
                </Form.Item>
                <Form.List name='images'>
                  {(fields, { add, remove, move }) => (
                    <div>
                      <Table
                        dataSource={this.getFieldValue('images')}
                        loading={this.state.isLoadingData}
                        pagination={false}
                        rowKey='id'
                        components={{
                          body: {
                            row: DragableBodyRow,
                          },
                        }}
                        onRow={(record, index) => ({
                          index,
                          moveRow: (dragIndex, hoverIndex) =>
                            move(dragIndex, hoverIndex),
                        })}
                        columns={[
                          { dataIndex: 'id', title: '#' },
                          {
                            dataIndex: 'url',
                            title: '圖片',
                            render: (url, asset) => (
                              <div
                                className='tableImg'
                                style={{ backgroundImage: `url(${url})` }}
                                alt='avatar'
                              />
                            ),
                          },
                          {
                            dataIndex: 'name',
                            title: '名稱',
                            render: (name, item) =>
                              this.getFieldValue('images').indexOf(item) === 0
                                ? `[封面] ${name}`
                                : name,
                          },
                          {
                            title: 'Action',
                            dataIndex: 'id',
                            key: 'tools',
                            width: 250,
                            render: (id, record) => (
                              <List
                                grid={{ gutter: 4, column: 3 }}
                                dataSource={[
                                  <DeleteConfirmButton
                                    loading={record.isDeleteData === true}
                                    size='small'
                                    onConfirm={() => {
                                      let images = this.getFieldValue('images');

                                      remove(images.indexOf(record));
                                    }}
                                  />,
                                  <Button
                                    type='default'
                                    size='small'
                                    icon={<EyeOutlined />}
                                    onClick={() =>
                                      this.setState({
                                        previewImage: { url: record.url },
                                      })
                                    }
                                  >
                                    檢視
                                  </Button>,
                                ]}
                                renderItem={(item) => (
                                  <List.Item>{item}</List.Item>
                                )}
                              />
                            ),
                          },
                        ]}
                      />
                    </div>
                  )}
                </Form.List>
              </Form.Item>

              <Divider>主要食材</Divider>
              <Form.List name='ingredients'>
                {(fields, { add, remove, move }) => {
                  return (
                    <Fragment>
                      {fields.length > 0 && (
                        <Table
                          pagination={false}
                          rowKey={(item, idx) => idx}
                          dataSource={fields}
                          components={{
                            body: {
                              row: DragableBodyRow,
                            },
                          }}
                          onRow={(record, index) => ({
                            index,
                            moveRow: (dragIndex, hoverIndex) =>
                              move(dragIndex, hoverIndex),
                          })}
                          columns={[
                            {
                              dataIndex: 'id',
                              title: '#',
                              render: (id, item, idx) => (
                                <Form.Item>{idx + 1}</Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'name',
                              title: '名稱',
                              render: (name, item, idx) => (
                                <Form.Item
                                  {...genFormItemAtrribute([idx, 'name'])}
                                  rules={[
                                    { required: true, message: '請填寫名稱' },
                                  ]}
                                >
                                  <Input />
                                </Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'portion',
                              title: '數量',
                              render: (portion, item, idx) => (
                                <Form.Item
                                  {...genFormItemAtrribute([idx, 'portion'])}
                                  rules={[
                                    { required: false, message: '請填寫數量' },
                                  ]}
                                >
                                  <Input />
                                </Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'unit',
                              title: '單位',
                              render: (unit, item, idx) => (
                                <Form.Item
                                  {...genFormItemAtrribute([idx, 'unit'])}
                                  rules={[
                                    { required: false, message: '請填寫單位' },
                                  ]}
                                >
                                  <Input />
                                </Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'id',
                              title: '商品代號',
                              render: (unit, item, idx) => (
                                <Form.Item
                                  {...genFormItemAtrribute([idx, 'id'])}
                                  rules={[
                                    {
                                      required: false,
                                      message: '請填寫商品代號',
                                    },
                                  ]}
                                >
                                  <Search
                                    placeholder='輸入商品代號或是關鍵字'
                                    onSearch={(value) =>
                                      this.productSearch(
                                        value,
                                        idx,
                                        'ingredients'
                                      )
                                    }
                                    enterButton='搜尋'
                                  />
                                </Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'name',
                              title: 'Action',
                              render: (name, item, idx) => (
                                <Form.Item>
                                  <Button danger onClick={() => remove(idx)}>
                                    刪除
                                  </Button>
                                </Form.Item>
                              ),
                            },
                          ]}
                        />
                      )}
                      <Button onClick={() => add()}>新增</Button>
                      {searchTotal > 0 && searchTitle == 'ingredients' && (
                        <Table
                          dataSource={tableData.rows}
                          loading={this.state.isLoadingData}
                          pagination={{
                            current: _.get(tableData, 'current', []),
                            total: _.get(tableData, 'total', 0),
                            pageSize: _.get(tableData, 'page_size', 0),
                            onChange: (page, page_size) => {
                              this.loadData({
                                page: page,
                                page_size: page_size,
                              });
                            },
                          }}
                          columns={[
                            { dataIndex: 'id', title: 'ID' },
                            { dataIndex: 'name', title: '名稱' },
                            { dataIndex: 'price', title: '價格' },
                            {
                              title: 'Action',
                              key: 'tools',
                              width: 250,
                              render: (text, record) => (
                                <List
                                  grid={{ gutter: 4, column: 3 }}
                                  dataSource={[
                                    <Button
                                      type='default'
                                      size='small'
                                      onClick={() => this.selectProduct(record)}
                                    >
                                      選擇
                                    </Button>,
                                  ]}
                                  renderItem={(item) => (
                                    <List.Item>{item}</List.Item>
                                  )}
                                />
                              ),
                            },
                          ]}
                        />
                      )}
                    </Fragment>
                  );
                }}
              </Form.List>

              <Divider>配菜 dishes</Divider>
              <Form.List name='dishes'>
                {(fields, { add, remove, move }) => {
                  return (
                    <Fragment>
                      {fields.length > 0 && (
                        <Table
                          pagination={false}
                          rowKey={(item, idx) => idx}
                          dataSource={fields}
                          components={{
                            body: {
                              row: DragableBodyRow,
                            },
                          }}
                          onRow={(record, index) => ({
                            index,
                            moveRow: (dragIndex, hoverIndex) =>
                              move(dragIndex, hoverIndex),
                          })}
                          columns={[
                            {
                              dataIndex: 'id',
                              title: '#',
                              render: (id, item, idx) => (
                                <Form.Item>{idx + 1}</Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'name',
                              title: '名稱',
                              render: (name, item, idx) => (
                                <Form.Item
                                  {...genFormItemAtrribute([idx, 'name'])}
                                  rules={[
                                    { required: true, message: '請填寫名稱' },
                                  ]}
                                >
                                  <Input />
                                </Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'portion',
                              title: '數量',
                              render: (portion, item, idx) => (
                                <Form.Item
                                  {...genFormItemAtrribute([idx, 'portion'])}
                                  rules={[
                                    { required: false, message: '請填寫數量' },
                                  ]}
                                >
                                  <Input />
                                </Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'unit',
                              title: '單位',
                              render: (unit, item, idx) => (
                                <Form.Item
                                  {...genFormItemAtrribute([idx, 'unit'])}
                                  rules={[
                                    { required: false, message: '請填寫單位' },
                                  ]}
                                >
                                  <Input />
                                </Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'id',
                              title: '商品代號',
                              render: (unit, item, idx) => (
                                <Form.Item
                                  {...genFormItemAtrribute([idx, 'id'])}
                                  rules={[
                                    {
                                      required: false,
                                      message: '請填寫商品代號',
                                    },
                                  ]}
                                >
                                  <Search
                                    placeholder='輸入商品代號或是關鍵字'
                                    onSearch={(value) =>
                                      this.productSearch(value, idx, 'dishes')
                                    }
                                    enterButton='搜尋'
                                  />
                                </Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'name',
                              title: 'Action',
                              render: (name, item, idx) => (
                                <Form.Item>
                                  <Button danger onClick={() => remove(idx)}>
                                    刪除
                                  </Button>
                                </Form.Item>
                              ),
                            },
                          ]}
                        />
                      )}
                      <Button onClick={() => add()}>新增</Button>
                      {searchTotal > 0 && searchTitle == 'dishes' && (
                        <Table
                          dataSource={tableData.rows}
                          loading={this.state.isLoadingData}
                          pagination={{
                            current: _.get(tableData, 'current', []),
                            total: _.get(tableData, 'total', 0),
                            pageSize: _.get(tableData, 'page_size', 0),
                            onChange: (page, page_size) => {
                              this.loadData({
                                page: page,
                                page_size: page_size,
                              });
                            },
                          }}
                          columns={[
                            { dataIndex: 'id', title: 'ID' },
                            { dataIndex: 'name', title: '名稱' },
                            { dataIndex: 'price', title: '價格' },
                            {
                              title: 'Action',
                              key: 'tools',
                              width: 250,
                              render: (text, record) => (
                                <List
                                  grid={{ gutter: 4, column: 3 }}
                                  dataSource={[
                                    <Button
                                      type='default'
                                      size='small'
                                      onClick={() => this.selectProduct(record)}
                                    >
                                      選擇
                                    </Button>,
                                  ]}
                                  renderItem={(item) => (
                                    <List.Item>{item}</List.Item>
                                  )}
                                />
                              ),
                            },
                          ]}
                        />
                      )}
                    </Fragment>
                  );
                }}
              </Form.List>
              <Divider>調味料 condiments</Divider>
              <Form.List name='condiments'>
                {(fields, { add, remove, move }) => {
                  return (
                    <Fragment>
                      {fields.length > 0 && (
                        <Table
                          pagination={false}
                          rowKey={(item, idx) => idx}
                          dataSource={fields}
                          components={{
                            body: {
                              row: DragableBodyRow,
                            },
                          }}
                          onRow={(record, index) => ({
                            index,
                            moveRow: (dragIndex, hoverIndex) =>
                              move(dragIndex, hoverIndex),
                          })}
                          columns={[
                            {
                              dataIndex: 'id',
                              title: '#',
                              render: (id, item, idx) => (
                                <Form.Item>{idx + 1}</Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'name',
                              title: '名稱',
                              render: (name, item, idx) => (
                                <Form.Item
                                  {...genFormItemAtrribute([idx, 'name'])}
                                  rules={[
                                    { required: true, message: '請填寫名稱' },
                                  ]}
                                >
                                  <Input />
                                </Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'portion',
                              title: '數量',
                              render: (portion, item, idx) => (
                                <Form.Item
                                  {...genFormItemAtrribute([idx, 'portion'])}
                                  rules={[
                                    { required: false, message: '請填寫數量' },
                                  ]}
                                >
                                  <Input />
                                </Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'unit',
                              title: '單位',
                              render: (unit, item, idx) => (
                                <Form.Item
                                  {...genFormItemAtrribute([idx, 'unit'])}
                                  rules={[
                                    { required: false, message: '請填寫單位' },
                                  ]}
                                >
                                  <Input />
                                </Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'id',
                              title: '商品代號',
                              render: (unit, item, idx) => (
                                <Form.Item
                                  {...genFormItemAtrribute([idx, 'id'])}
                                  rules={[
                                    {
                                      required: false,
                                      message: '請填寫商品代號',
                                    },
                                  ]}
                                >
                                  <Search
                                    placeholder='輸入商品代號或是關鍵字'
                                    onSearch={(value) =>
                                      this.productSearch(
                                        value,
                                        idx,
                                        'condiments'
                                      )
                                    }
                                    enterButton='搜尋'
                                  />
                                </Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'name',
                              title: 'Action',
                              render: (name, item, idx) => (
                                <Form.Item>
                                  <Button danger onClick={() => remove(idx)}>
                                    刪除
                                  </Button>
                                </Form.Item>
                              ),
                            },
                          ]}
                        />
                      )}
                      <Button onClick={() => add()}>新增</Button>
                      {searchTotal > 0 && searchTitle == 'condiments' && (
                        <Table
                          dataSource={tableData.rows}
                          loading={this.state.isLoadingData}
                          pagination={{
                            current: _.get(tableData, 'current', []),
                            total: _.get(tableData, 'total', 0),
                            pageSize: _.get(tableData, 'page_size', 0),
                            onChange: (page, page_size) => {
                              this.loadData({
                                page: page,
                                page_size: page_size,
                              });
                            },
                          }}
                          columns={[
                            { dataIndex: 'id', title: 'ID' },
                            { dataIndex: 'name', title: '名稱' },
                            { dataIndex: 'price', title: '價格' },
                            {
                              title: 'Action',
                              key: 'tools',
                              width: 250,
                              render: (text, record) => (
                                <List
                                  grid={{ gutter: 4, column: 3 }}
                                  dataSource={[
                                    <Button
                                      type='default'
                                      size='small'
                                      onClick={() => this.selectProduct(record)}
                                    >
                                      選擇
                                    </Button>,
                                  ]}
                                  renderItem={(item) => (
                                    <List.Item>{item}</List.Item>
                                  )}
                                />
                              ),
                            },
                          ]}
                        />
                      )}
                    </Fragment>
                  );
                }}
              </Form.List>
              <Divider>醃料</Divider>
              <Form.List name='dips'>
                {(fields, { add, remove, move }) => {
                  return (
                    <Fragment>
                      {fields.length > 0 && (
                        <Table
                          pagination={false}
                          rowKey={(item, idx) => idx}
                          dataSource={fields}
                          components={{
                            body: {
                              row: DragableBodyRow,
                            },
                          }}
                          onRow={(record, index) => ({
                            index,
                            moveRow: (dragIndex, hoverIndex) =>
                              move(dragIndex, hoverIndex),
                          })}
                          columns={[
                            {
                              dataIndex: 'id',
                              title: '#',
                              render: (id, item, idx) => (
                                <Form.Item>{idx + 1}</Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'name',
                              title: '名稱',
                              render: (name, item, idx) => (
                                <Form.Item
                                  {...genFormItemAtrribute([idx, 'name'])}
                                  rules={[
                                    { required: true, message: '請填寫名稱' },
                                  ]}
                                >
                                  <Input />
                                </Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'portion',
                              title: '數量',
                              render: (portion, item, idx) => (
                                <Form.Item
                                  {...genFormItemAtrribute([idx, 'portion'])}
                                  rules={[
                                    { required: false, message: '請填寫數量' },
                                  ]}
                                >
                                  <Input />
                                </Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'unit',
                              title: '單位',
                              render: (unit, item, idx) => (
                                <Form.Item
                                  {...genFormItemAtrribute([idx, 'unit'])}
                                  rules={[
                                    { required: false, message: '請填寫單位' },
                                  ]}
                                >
                                  <Input />
                                </Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'id',
                              title: '商品代號',
                              render: (unit, item, idx) => (
                                <Form.Item
                                  {...genFormItemAtrribute([idx, 'id'])}
                                  rules={[
                                    {
                                      required: false,
                                      message: '請填寫商品代號',
                                    },
                                  ]}
                                >
                                  <Search
                                    placeholder='輸入商品代號或是關鍵字'
                                    onSearch={(value) =>
                                      this.productSearch(value, idx, 'dips')
                                    }
                                    enterButton='搜尋'
                                  />
                                </Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'name',
                              title: 'Action',
                              render: (name, item, idx) => (
                                <Form.Item>
                                  <Button danger onClick={() => remove(idx)}>
                                    刪除
                                  </Button>
                                </Form.Item>
                              ),
                            },
                          ]}
                        />
                      )}
                      <Button onClick={() => add()}>新增</Button>
                      {searchTotal > 0 && searchTitle == 'dips' && (
                        <Table
                          dataSource={tableData.rows}
                          loading={this.state.isLoadingData}
                          pagination={{
                            current: _.get(tableData, 'current', []),
                            total: _.get(tableData, 'total', 0),
                            pageSize: _.get(tableData, 'page_size', 0),
                            onChange: (page, page_size) => {
                              this.loadData({
                                page: page,
                                page_size: page_size,
                              });
                            },
                          }}
                          columns={[
                            { dataIndex: 'id', title: 'ID' },
                            { dataIndex: 'name', title: '名稱' },
                            { dataIndex: 'price', title: '價格' },
                            {
                              title: 'Action',
                              key: 'tools',
                              width: 250,
                              render: (text, record) => (
                                <List
                                  grid={{ gutter: 4, column: 3 }}
                                  dataSource={[
                                    <Button
                                      type='default'
                                      size='small'
                                      onClick={() => this.selectProduct(record)}
                                    >
                                      選擇
                                    </Button>,
                                  ]}
                                  renderItem={(item) => (
                                    <List.Item>{item}</List.Item>
                                  )}
                                />
                              ),
                            },
                          ]}
                        />
                      )}
                    </Fragment>
                  );
                }}
              </Form.List>

              <Divider>步驟 steps</Divider>
              <Form.List name='steps'>
                {(fields, { add, remove, move }) => {
                  return (
                    <Fragment>
                      {fields.length > 0 && (
                        <Table
                          pagination={false}
                          rowKey={(item, idx) => idx}
                          dataSource={fields}
                          components={{
                            body: {
                              row: DragableBodyRow,
                            },
                          }}
                          onRow={(record, index) => ({
                            index,
                            moveRow: (dragIndex, hoverIndex) =>
                              move(dragIndex, hoverIndex),
                          })}
                          columns={[
                            {
                              dataIndex: 'id',
                              title: '#',
                              render: (id, item, idx) => (
                                <Form.Item>{idx + 1}</Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'name',
                              title: '圖片',
                              render: (name, item, idx) => (
                                <Form.Item
                                  {...genFormItemAtrribute(
                                    [idx, 'image'],
                                    '圖片 寬800x高800'
                                  )}
                                  style={{ minHeight: 166 }}
                                >
                                  <AvatarUpload />
                                </Form.Item>
                              ),
                            },
                            {
                              dataIndex: 'portion',
                              title: '說明',
                              render: (portion, item, idx) => (
                                <Fragment>
                                  <Form.Item
                                    {...genFormItemAtrribute(
                                      [idx, 'desc'],
                                      '說明'
                                    )}
                                    rules={[
                                      { required: true, message: '請填寫說明' },
                                    ]}
                                  >
                                    <Input />
                                  </Form.Item>
                                  <Form.Item
                                    {...genFormItemAtrribute(
                                      [idx, 'tip'],
                                      '訣竅'
                                    )}
                                  >
                                    <Input />
                                  </Form.Item>
                                </Fragment>
                              ),
                            },
                            {
                              dataIndex: 'name',
                              title: 'Action',
                              render: (name, item, idx) => (
                                <Form.Item>
                                  <Button danger onClick={() => remove(idx)}>
                                    刪除
                                  </Button>
                                </Form.Item>
                              ),
                            },
                          ]}
                        />
                      )}
                      <Button onClick={() => add()}>新增</Button>
                    </Fragment>
                  );
                }}
              </Form.List>
              <Divider>了解更多</Divider>
              <Form.Item
                {...genFormItemAtrribute('source', '')}
                validateTrigger='onBlur'
              >
                <BraftEditor
                  style={{ border: '1px solid' }}
                  className='my-editor'
                  controls={controls}
                  placeholder='請輸入文字'
                  language='zh-hant'
                  defaultValue={source}
                  contentStyle={{
                    height: 150,
                    boxShadow: 'inset 0 1px 3px rgba(0,0,0,.1)',
                  }}
                  onChange={this.sourceChange}
                />
              </Form.Item>
            </Form>
          </div>

          <Modal
            visible={this.state.previewImage}
            footer={null}
            onCancel={() => this.setState({ previewImage: null })}
          >
            <img
              alt='Preview'
              style={{ width: '100%' }}
              src={this.state.previewImage && this.state.previewImage.url}
            />
          </Modal>
        </Skeleton>
      </Layout>
    );
  }
}

const devRecipeInfo = {
  name: '',
  type: 1,
  desc: null,
  sort: null,
  logo: null,
  pdfs: [],
  images: [],
};

/* DnD */
let dragingIndex = -1;

class BodyRow extends React.Component {
  render() {
    const {
      isOver,
      connectDragSource,
      connectDropTarget,
      moveRow,
      ...restProps
    } = this.props;
    const style = { ...restProps.style, cursor: 'move' };

    let className = restProps.className;
    if (isOver) {
      if (restProps.index > dragingIndex) {
        className += ' drop-over-downward';
      }
      if (restProps.index < dragingIndex) {
        className += ' drop-over-upward';
      }
    }

    return connectDragSource(
      connectDropTarget(
        <tr {...restProps} className={className} style={style} />
      )
    );
  }
}

const rowSource = {
  beginDrag(props) {
    dragingIndex = props.index;
    return {
      index: props.index,
    };
  },
};

const rowTarget = {
  drop(props, monitor) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Time to actually perform the action
    props.moveRow(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  },
};

const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
}))(
  DragSource('row', rowSource, (connect) => ({
    connectDragSource: connect.dragSource(),
  }))(BodyRow)
);

/* DnD */



// WEBPACK FOOTER //
// ./src/views/Recipe/RecipeInfo.js